__webpack_require__.p = "https://production.d2egdmwcq2isjm.amplifyapp.com/";